module.exports = __webpack_public_path__ + "static/media/breadcrumb-head-selected.917b5607.svg";